import { Button } from "primereact/button";
import { Carousel } from "primereact/carousel"
import { useRef, useState } from "react"

const FeaturesAndBenetfitsCarusel = () => {

    const [caruselImages, setCaruselImages] = useState<any>([
        "benefitCaruselImg1.jpg", "benefitCaruselImg2.jpg", "benefitCaruselImg3.jpg", "benefitCaruselImg4.jpg", "benefitCaruselImg5.jpg", "benefitCaruselImg6.jpg"
    ])

    const [page, setPage] = useState(0);

    const responsiveOptions = [
        {
            breakpoint: '1440px',
            numVisible: 4,
            numScroll: 1
        },
        {
            breakpoint: '1024px',
            numVisible: 3,
            numScroll: 1
        },
        {
            breakpoint: '768px',
            numVisible: 2,
            numScroll: 1
        },
        {
            breakpoint: '576px',
            numVisible: 1,
            numScroll: 1
        }
    ];


    const patientTemplate = (imgage: any) => {

        return (
            <div className='flex flex-column justify-content-start align-items-start m-2 p-4 gap-3'
                style={{
                    whiteSpace: "nowrap", backgroundColor: "#FFFFFF",height:"35vh"
                }}>
                <img src={imgage}
                    style={{ width: "100%", height: "15vh", objectFit: "cover" }} />


                {imgage === "benefitCaruselImg1.jpg" && <>
                    <p className='text-xl m-0 font-bold' style={{ color: "#2D3967", whiteSpace: "wrap"}}>Intelligent Detection and Feedback</p>
                    <p className="text-sm m-0" style={{ color: "#727A99", whiteSpace: "wrap",overflow:"hidden",textOverflow:"ellipsis" }}>Artificial intelligence analyzes your movements and helps you do them with correct form.</p>
                </>}

                {imgage === "benefitCaruselImg2.jpg" && <>
                    <p className='text-xl m-0 font-bold' style={{ color: "#2D3967", whiteSpace: "wrap" }}>Step by Step Guidance</p>
                    <p className="text-sm m-0" style={{ color: "#727A99", whiteSpace: "wrap",overflow:"hidden"  }}>It guides users step by step for
                        each movement helps you do them with correct form.</p>
                </>}

                {imgage === "benefitCaruselImg3.jpg" && <>
                    <p className='text-xl m-0 font-bold' style={{ color: "#2D3967", whiteSpace: "wrap" }}>Customized Guidance</p>
                    <p className="text-sm m-0" style={{ color: "#727A99", whiteSpace: "wrap",overflow:"hidden"}}>It offers personalized recommendations Personalized programs based on the user's goals and level.</p>
                </>}

                {imgage === "benefitCaruselImg4.jpg" && <>
                    <p className='text-xl m-0 font-bold' style={{ color: "#2D3967", whiteSpace: "wrap" }}>Boosted Compliance</p>
                    <p className="text-sm m-0" style={{ color: "#727A99", whiteSpace: "wrap",overflow:"hidden"}}>Artificial intelligence analyzes your movements and helps you do them with correct form.</p>
                </>}

                {imgage === "benefitCaruselImg5.jpg" && <>
                    <p className='text-xl m-0 font-bold' style={{ color: "#2D3967", whiteSpace: "wrap" }}>Intelligent Detection and Feedback</p>
                    <p className="text-sm m-0" style={{ color: "#727A99", whiteSpace: "wrap",overflow:"hidden"}}>Artificial intelligence analyzes your movements and helps you do them with correct form.</p>
                </>}

                {imgage === "benefitCaruselImg6.jpg" && <>
                    <p className='text-xl m-0 font-bold' style={{ color: "#2D3967", whiteSpace: "wrap" }}>Customized Guidance</p>
                    <p className="text-sm m-0" style={{ color: "#727A99", whiteSpace: "wrap",overflow:"hidden"}}>Artificial intelligence analyzes your movements and helps you do them with correct form.</p>
                </>}

            </div>
        )
    }

    const scrollForward = () => {
        if (page < 2) {
            setPage(page + 1);
        }
    };

    const scrollBackward = () => {
        if (page > 0) {
            setPage(page - 1);
        }
    };

    return (
        <>
            <div className="flex md:justify-content-end md:pr-3 justify-content-center gap-2 mb-2">
                <Button
                    className="benefitsCaruselButton"
                    icon="pi pi-angle-left"
                    onClick={scrollBackward}
                    style={{
                        borderRadius: "20px",
                        width: "2.5rem",
                        height: "2.5rem",
                        padding: "0",
                        background: "white",
                        border: "1px solid #2D3967",
                        color: "#2D3967"
                    }} />
                <Button
                    icon="pi pi-angle-right"
                    className="benefitsCaruselButton"
                    onClick={scrollForward}
                    style={{
                        borderRadius: "20px",
                        width: "2.5rem",
                        height: "2.5rem",
                        padding: "0",
                        background: "white",
                        border: "1px solid #2D3967",
                        color: "#2D3967"
                    }} />
            </div>
            <Carousel
                page={page}
                onPageChange={(e) => setPage(e.page)}
                value={caruselImages}
                numVisible={4}
                numScroll={1}
                itemTemplate={patientTemplate}
                responsiveOptions={responsiveOptions} />
        </>
    )
}

export default FeaturesAndBenetfitsCarusel